import '../../index.scss'

const Sidebar = () => {
	return (
		<section id="sidebar">
			<div className="inner">
				<nav>
					<ul>
						<li><a href="#intro">Bem vindo!</a></li>
						<li><a href="#two">O que fazemos?</a></li>
						<li><a href="#templates">Principais Templates</a></li>
						<li><a href="#three">Faça um orçamento</a></li>
					</ul>
				</nav>
			</div>
		</section>
	)
}

export default Sidebar